import { formatUnixTimeStampToDate } from '~/src/libs'

export const convertStatement = (data: any) => {
  return {
    statement: data.items.map((item: any) => {
      return {
        company: item.user.companyName ?? '',
        name: item.user.name ?? '',
        date: formatUnixTimeStampToDate(item.createdAt),
        id: item.id ?? '',
        userId: item.user.id,
        file: item.file ?? { filename: '', url: '' },
      }
    }),
    pagination: data.pagination,
    data,
  }
}
